import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { namedOperations } from '#src/__generated__/operations.ts';
import { useMutation } from '#src/hooks/graphql/useMutation.ts';

import type {
  DestroyReferralMutation,
  DestroyReferralMutationVariables,
} from './__generated__/useDestroyReferral.graphql.ts';

const DESTROY_REFERRAL_MUTATION = gql`
  mutation DestroyReferralMutation($input: destroyReferralInput!) {
    destroyReferral(input: $input) {
      errors {
        message
        code
      }
    }
  }
` as TypedDocumentNode<
  DestroyReferralMutation,
  DestroyReferralMutationVariables
>;

export const useDestroyReferral = () => {
  const [destroy] = useMutation(DESTROY_REFERRAL_MUTATION, {
    showErrorsWithSnackNotification: true,
  });

  return async (referralId: string) => {
    await destroy({
      variables: {
        input: {
          referralId,
        },
      },
      refetchQueries: [namedOperations.Query.ReferralListQuery],
    });
  };
};
